export class IconSpriteConfig {
  public path = '';
}
